
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/czy-zachowac-numer",
      function () {
        return require("private-next-pages/czy-zachowac-numer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/czy-zachowac-numer"])
      });
    }
  